'use client'

import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from '@teqplay/ui'
import { useLocale } from 'next-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faChevronDown, faLanguage } from '@fortawesome/pro-solid-svg-icons'

import { usePathname, useRouter } from '@/i18n/navigation'

import './ActionSection.scss'

function ActionSection() {
  const locale = useLocale()
  const router = useRouter()
  const pathname = usePathname()

  const languageLabel = locale === 'pt' ? 'Português' : 'English'

  const handleLanguageChange = (newLocale: 'en' | 'pt') => {
    router.push({ pathname }, { locale: newLocale })
  }

  return (
    <ul className="action-section-ul">
      <DropdownMenu>
        <DropdownMenuTrigger asChild style={{ cursor: 'pointer' }}>
          <Button variant="link">
            <FontAwesomeIcon icon={faLanguage} />
            {languageLabel}
            <FontAwesomeIcon icon={faChevronDown} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent className="dropdown-language" align="end">
          <DropdownMenuItem onClick={() => handleLanguageChange('en')}>
            {locale === 'en' && <FontAwesomeIcon icon={faCheck} />} English
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => handleLanguageChange('pt')}>
            {locale === 'pt' && <FontAwesomeIcon icon={faCheck} />} Português
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </ul>
  )
}

export default ActionSection
